(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3584],{

/***/ 81903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return __webpack_require__(290);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Apps_Resources; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/index.js + 16 modules
var Resources = __webpack_require__(48474);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(76136);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/services/index.js + 20 modules
var services = __webpack_require__(17104);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
;// CONCATENATED MODULE: ./src/ResourcesSectionAcademy/index.js







const ResourcesSectionAcademy = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                spacing: {
                    mb: 6
                },
                sx: {
                    textAlign: "center"
                },
                children: "Advance Your Skills with Prism Academy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        justify: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        md: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            my: true,
                            utility: {
                                justify: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            spacing: {
                                                ml: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    spacing: {
                                                        mb: 3
                                                    },
                                                    children: "125+ videos and hours of learning material taught by highly-technical experts"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    spacing: {
                                                        mb: 3
                                                    },
                                                    children: "Improve accuracy interpreting and presenting your research"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    spacing: {
                                                        mb: 3
                                                    },
                                                    children: "Master the art of data visualization and presentation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    spacing: {
                                                        mb: 3
                                                    },
                                                    children: "Become more efficient and productive using Prism"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                                            href: "/prism-academy",
                                            styleType: "secondary",
                                            isOutline: true,
                                            size: "s",
                                            spacing: {
                                                mt: 5,
                                                ml: 5
                                            },
                                            children: "Learn More"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    md: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/resources/prism-academy.png"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
/* harmony default export */ var src_ResourcesSectionAcademy = (ResourcesSectionAcademy);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TileBlock/index.js + 1 modules
var TileBlock = __webpack_require__(16887);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TileBlock/Image.js
var TileBlock_Image = __webpack_require__(178);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TileBlock/Body.js
var Body = __webpack_require__(63669);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 2 modules
var PostElement = __webpack_require__(77626);
;// CONCATENATED MODULE: ./src/ResourcesSectionQuickCals/index.js








const ResourcesSectionQuickCals = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                sx: {
                    textAlign: "center"
                },
                children: "Quick Calcs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH3 */.Q2, {
                center: true,
                children: "Run statistical analyses quickly and directly in your browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        justify: "center"
                    },
                    spacing: {
                        mt: 12
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                        sm: 12,
                        md: 10,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileBlock/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileBlock_Image/* default */.Z, {
                                        src: "/images/graphpad/resources/quickcalcs-categorical-data.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Title */.Z.Title, {
                                                href: "/quickcalcs/catMenu/",
                                                children: "Categorical Data"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Description */.Z.Description, {
                                                children: "Fisher's, Chi square, McNemar's, Sign test, CI of proportion, NNT (number needed to treat), kappa."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileBlock/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileBlock_Image/* default */.Z, {
                                        src: "/images/graphpad/resources/quickcalcs-continuous-data.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Title */.Z.Title, {
                                                href: "/quickcalcs/contMenu/",
                                                children: "Continuous data"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Description */.Z.Description, {
                                                children: "Descriptive statistics, detect outlier, t test, CI of mean / difference / ratio / SD, multiple comparisons tests, linear regression."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileBlock/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileBlock_Image/* default */.Z, {
                                        src: "/images/graphpad/resources/quickcalcs-statistical-distributions.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Title */.Z.Title, {
                                                href: "/quickcalcs/distMenu/",
                                                children: "Statistical distributions and interpreting P values"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Description */.Z.Description, {
                                                children: "Calculate P from t, z, r, F or chi-square, or vice-versa. View Binomial, Poisson or Gaussian distribution. Correct a P value for multiple comparisons and Bayes."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileBlock/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileBlock_Image/* default */.Z, {
                                        src: "/images/graphpad/resources/quickcalcs-random-numbers.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Title */.Z.Title, {
                                                href: "/quickcalcs/randMenu/",
                                                children: "Random numbers"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Description */.Z.Description, {
                                                children: "Assign subjects to groups, simulate data."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileBlock/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileBlock_Image/* default */.Z, {
                                        src: "/images/graphpad/resources/quickcalcs-chemical-data.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Title */.Z.Title, {
                                                href: "/quickcalcs/chemMenu/",
                                                children: "Chemical and radiochemical data"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Description */.Z.Description, {
                                                children: "Create and convert molar solutions, convert moles & grams, radioactivity calculations."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
/* harmony default export */ var src_ResourcesSectionQuickCals = (ResourcesSectionQuickCals);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./src/KnowledgebaseSearchBar/index.js
var KnowledgebaseSearchBar = __webpack_require__(30984);
;// CONCATENATED MODULE: ./src/ResourcesSectionKnowledgebase/index.js





const ResourcesSectionKnowledgebase = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                opacity: 100,
                spacing: {
                    mb: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgebaseSearchBar/* default */.Z, {
                        hasOwnSection: false
                    })
                })
            })
        ]
    });
/* harmony default export */ var src_ResourcesSectionKnowledgebase = (ResourcesSectionKnowledgebase);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
;// CONCATENATED MODULE: ./src/ResourcesSectionPopularArticles/index.js







const ResourcesSectionPopularArticles = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH3 */.Q2, {
                center: true,
                className: "mb-6",
                children: "Popular Articles"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        justify: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        md: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            my: true,
                            utility: {
                                justify: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                        spacing: {
                                            ml: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/activating-a-prism-license/",
                                                    children: "How do I activate a Prism license?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/prism-academy/",
                                                    children: "How do I access Prism Academy?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/what-is-the-difference-between-correlation-and-linear-regression/",
                                                    children: "What is the difference between correlation and linear regression?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/the-anova-table-ss-and-df-in-two-way-anova/",
                                                    children: "Understanding the ANOVA table (SS, df, MS, F) in two-way ANOVA"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                        spacing: {
                                            ml: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faqid/1790/",
                                                    children: "How to choose a statistical test?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faqid/1726/",
                                                    children: "How to plot a dose-response curves?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/graph-tip-how-to-make-an-xy-graph-with-a-time-scale-on-the-x-axis/",
                                                    children: "How to make an XY graph with a time-scale on the X axis?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                sx: {
                                                    fontSize: "m"
                                                },
                                                spacing: {
                                                    mb: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://www.graphpad.com/support/faq/how-to-compare-two-means-when-the-groups-have-different-standard-deviations/",
                                                    children: "How to compare two means when the groups have different standard deviations?"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
/* harmony default export */ var src_ResourcesSectionPopularArticles = (ResourcesSectionPopularArticles);

// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
;// CONCATENATED MODULE: ./src/Apps/Resources/index.js












const resourcesLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
const ResourcesApp = (0,Resources/* default */.Z)({
    Layout: resourcesLayout,
    contentfulProps: {
        environment: "master",
        space: "gyag548snr3z",
        accessToken: "G5ccCuVhJnKaI_A32Fb0iqg4-_Ob0dHapTddg34pJ-o",
        proxy: null,
        filter: {
            "fields.id[in]": "getting-started,tutorials-guides,latest-resources"
        }
    },
    pageProps: {
        brandCode: "gp",
        siteDomain: "https://www.graphpad.com",
        cdnDomain: "cdn.graphpad.com",
        customSections: [
            {
                id: "academy",
                blockOrder: 1,
                Component: src_ResourcesSectionAcademy
            },
            {
                id: "quick-calcs",
                blockOrder: 2,
                Component: src_ResourcesSectionQuickCals
            },
            {
                id: "knowledgebase",
                blockOrder: 3,
                Component: src_ResourcesSectionKnowledgebase
            },
            {
                id: "popular-articles",
                blockOrder: 4,
                Component: src_ResourcesSectionPopularArticles,
                props: {
                    className: "pt-0"
                }
            }
        ]
    }
});
/* harmony default export */ var Apps_Resources = ((0,pipe/* default */.Z)(ResourcesApp, withErrorHandling/* default */.Z, services/* default */.ZP));

;// CONCATENATED MODULE: ./pages/resources/index.js



/***/ }),

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/parsers/isInt.js
var isInt = __webpack_require__(21607);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
;// CONCATENATED MODULE: ./src/AppError/Error404.js






const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("app-error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("404.META_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("404.TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("404.DESCRIPTION")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js






const Error500 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. Something has gone wrong with the application.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please try again later or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error500 = (Error500);

;// CONCATENATED MODULE: ./src/AppError/Error503.js




const Error503 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Service Unavailable"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable."
            })
        ]
    });
/* harmony default export */ var AppError_Error503 = (Error503);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js





const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            utility: {
                bgColor: "black"
            },
            className: "panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = ( false ? 0 : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
// EXTERNAL MODULE: ./src/sentry.js + 123 modules
var sentry = __webpack_require__(77039);
;// CONCATENATED MODULE: ./src/AppError/AppError.js















const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404,
    503: AppError_Error503
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    const errorCode = (0,isInt/* default */.Z)(error.code) ? error.code : 500;
    if (res) {
        res.statusCode = errorCode;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.code !== 503 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 59093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87385);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76136);






/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 71802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38100);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 30984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_r2_SectionSearchBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6930);
/* harmony import */ var _insightfulscience_atomic_react_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22950);
/* harmony import */ var _insightfulscience_atomic_react_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6470);
/* harmony import */ var _insightfulscience_atomic_react_InputGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88554);
/* harmony import */ var _insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61672);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);








function KnowledgebaseSearchBar(param) {
    let { hasOwnSection =true  } = param;
    const searchInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const SectionWrapper = hasOwnSection ? _insightfulscience_atomic_react_r2_SectionSearchBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    function handleSearchForm(event) {
        event.preventDefault();
        const searchInput = searchInputRef.current.value;
        const searchIndex = "520255";
        if (searchInput.length) {
            window.location = "/search/?index=".concat(searchIndex, "&searchquery=").concat(searchInput);
        }
        return false;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_SectionSearchBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: "Explore the Knowledgebase"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onSubmit: handleSearchForm,
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_InputGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_InputGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Field */ .Z.Field, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    forwardRef: searchInputRef,
                                    placeholder: "Search..."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_InputGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Append */ .Z.Append, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_InputGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Button */ .Z.Button, {
                                    type: "submit",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        name: "search"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
KnowledgebaseSearchBar.propTypes = {
    hasOwnSection: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (KnowledgebaseSearchBar);


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24155);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    size: "s",
                    href: "/demos/",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9321,5568,8135,2660,8825,7718,6136,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(81903); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);